import { graphql } from "../gql";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";

const CreateBulkClassRoomCreationIntentMutation = graphql(`
  mutation createBulkClassRoomCreationIntent(
    $input: CreateBulkClassRoomCreationIntentInput!
  ) {
    createBulkClassRoomCreationIntent(input: $input) {
      id
      createdAt
      startDate
      numberOfWeeks
      maxClassRoomNumber
      user1on1ClassroomPlanToBeRedeemedId
      teacher {
        id
        givenName
        familyName
      }
      user {
        id
        givenName
        familyName
      }
      weekSlots {
        dayOfWeek
        startTime
        endTime
      }
    }
  }
`);

export function useCreateBulkClassRoomCreationIntent() {
  const [createBulkClassRoomCreationIntentMutation, { loading }] = useMutation(
    CreateBulkClassRoomCreationIntentMutation,
  );

  const createBulkClassRoomCreationIntent = useCallback(
    async (input: {
      teacherId: string;
      studentId?: string;
      startDate: string;
      numberOfWeeks: number;
      maxClassRoomNumber?: number;
      user1on1ClassroomPlanToBeRedeemedId?: string;
      weekSlots: Array<{
        dayOfWeek: number;
        startTime: string;
        endTime: string;
      }>;
    }) => {
      const res = await createBulkClassRoomCreationIntentMutation({
        variables: {
          input,
        },
      });

      const intent = res.data?.createBulkClassRoomCreationIntent;
      if (!intent)
        throw new Error("Unable to create bulk classroom creation intent");

      return intent;
    },
    [createBulkClassRoomCreationIntentMutation],
  );

  return {
    loading,
    createBulkClassRoomCreationIntent,
  };
}
